/**
 * A number picked by dragging: founders, a price, hours. The value shows beside the label in the format it means
 * ("$60", "25 founders"), and arrow keys step it. A range input underneath, so keyboards and screen readers get it free.
 */
import { useId, type CSSProperties } from 'react'
import s from './RangeField.module.css'

export function RangeField({
  label,
  value,
  min,
  max,
  step = 1,
  format = String,
  hint,
  onChange,
}: {
  label: string
  value: number
  min: number
  max: number
  step?: number
  format?: (v: number) => string
  /** A short line under the slider: the basis, the source. */
  hint?: string
  onChange: (v: number) => void
}) {
  const id = useId()
  const pct = ((value - min) / (max - min)) * 100
  return (
    <div className={s.field}>
      <div className={s.head}>
        <label htmlFor={id} className={s.label}>
          {label}
        </label>
        <output htmlFor={id} className={s.value}>
          {format(value)}
        </output>
      </div>
      <input
        id={id}
        className={s.range}
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        aria-valuetext={format(value)}
        style={{ '--fill': `${pct}%` } as CSSProperties}
        onChange={(e) => onChange(Number(e.target.value))}
      />
      {hint && <span className={s.hint}>{hint}</span>}
    </div>
  )
}
